import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=22809a31&scoped=true&"
import script from "./Quiz.vue?vue&type=script&lang=ts&"
export * from "./Quiz.vue?vue&type=script&lang=ts&"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=22809a31&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22809a31",
  null
  
)

export default component.exports